/**
 * Builds the anchor-map key for a drawer pane in a specific window/tab. Shared so
 * the registration mutator and the selectors always derive the identical key.
 */
export default function getAnchorMapKey(tabId: string, drawerPaneId: string): string {
    return `${tabId}:${drawerPaneId}`;
}
